import { createElement } from 'react';
import { b as __rest, a1 as LinkCell$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var LinkCell = function LinkCell(_a) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(LinkCell$1, __assign({
    iconBrand: "uq-ec-"
  }, props));
};
LinkCell.displayName = 'LinkCell';

export { LinkCell };
